
import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

const PrivateRoutes = ({ Component }) => {
  const token = localStorage.getItem("authToken");
  
  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }
  
  return <Component />;
};

PrivateRoutes.propTypes = {
  Component: PropTypes.elementType.isRequired,
};

export default React.memo(PrivateRoutes);
